import { CalendarDate } from "@/src/types/calendarDay";
import { DateData } from "@/src/types/DateData";

interface Props {
  day: DateData;
  handleDateSelect: (day: CalendarDate) => void;
  isSelected: boolean;
}

export default function DateCell({ day, handleDateSelect, isSelected }: Props) {
  return (
    //DESKTOP

    <div
      onClick={() => day.isSelectable && handleDateSelect(day)}
      className={`h-16 flex items-center justify-center text-lg font-medium transition-all duration-200 relative
        w-10 pt-2 pb-2 h-fit rounded-lg
        ${day.isToday ? "bg-gray-100 text-red-500" : ""}
        ${
          day.isCurrentMonth
            ? day.isSelectable
              ? "cursor-pointer hover:bg-green-50 hover:text-green-600"
              : "text-gray-300 cursor-not-allowed"
            : "text-gray-300"
        }
        ${isSelected ? "bg-green-500 text-white" : ""}
      `}
    >
      {day.day}
    </div>
  );
}
